import { useCallback, useContext } from 'react';
import { Box, Button } from '@alf/uikit';
import { LINE_VIEW_TYPES } from '@namespace/common';
import { LOCAL_STORAGE_KEYS } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { UserContext } from '@namespace/user';

import styles from './index.module.css';

export const SettingsLineView = () => {
  const [state = {}, userActions] = useContext(UserContext);
  const { settings = {} } = state;
  const { lineViewType } = settings;
  const { CHANGE_LINE_VIEW } = userActions;
  const { t } = useI18n();
  const lineView = [
    {
      name: t('web.settings.lineView.button'),
      icon: 'icons/general/state/line-buttons',
      value: LINE_VIEW_TYPES.BUTTON
    },
    {
      name: t('web.settings.lineView.table'),
      icon: 'icons/general/state/line-tables',
      value: LINE_VIEW_TYPES.TABLE
    }
  ];

  const handleChangeLineView = useCallback((value) => {
    CHANGE_LINE_VIEW(LOCAL_STORAGE_KEYS.LINE_VIEW, value);
  }, []);

  return (
    <Box data-role="settings-line-view" gap="s">
      {lineView.map(({ name, icon, value }) => {
        const isActive = lineViewType === value;
        return (
          <Button
            key={value}
            actionType={`color${isActive ? '5' : '3'}`}
            intent={isActive ? 'primary' : 'secondary'}
            onClick={() => handleChangeLineView(value)}
            iconLeft={<Icon name={icon} />}
            data-role={`settings-line-view-${name.toLowerCase()}`}
            fullWidth={true}
            className={styles.button}
          >
            {name}
          </Button>
        );
      })}
    </Box>
  );
};
